// export const apiConfig = {
//     baseUrl: process.env.NEXT_PUBLIC_API_URL
//         ? process.env.NEXT_PUBLIC_API_URL
//         : `https://api-${window.location.hostname}`,
// };

type ApiConfig = {
    baseUrl: string;
};

function resolveBackendBaseUrl(): string {
    const url = process.env.NEXT_PUBLIC_API_URL;

    if (!url) throw new Error('Missing env NEXT_PUBLIC_API_URL');

    return url;
}

export const apiConfig: ApiConfig = {
    baseUrl: resolveBackendBaseUrl(),
};
